import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '|/helpers/app-framework';
import ArrowDown from '|/icons/arrow-down.svg';
import theme from '../../../components/base/theme';

export const Arrow = styled(ArrowDown)`
  transform: ${props =>
    props.expanded === 'true' ? 'rotate(0deg)' : 'rotate(180deg)'};
  color: #00aed9;
  width: 10px;
  height: 10px;
`;

export const Wrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  border-radius: 0.3rem;

  @media (width >= 1280px) {
    padding: 0 30px;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50px;

  @media (width >= 768px) {
    flex-basis: 46%;
  }
`;

export const EditButton = styled.button`
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  border: none;
  color: #00aed9;

  &:focus {
    outline: none;
  }
`;

export const EditButtonRightAligned = styled.button`
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  border: none;
  color: #00aed9;
  margin-top: 20px;
  margin-left: auto;
  display: flex;
  align-items: baseline;

  &:focus {
    outline: none;
  }
`;

export const Section = styled.section`
  padding-top: 30px;

  & > ${EditButton} {
    margin-top: 0;
  }
`;

export const Heading = styled.h2`
  color: #183558;
  font-size: 20px;
  margin-bottom: 14px;
`;

export const Box = styled.div`
  border-top: 1px solid var(--colors-neutral-gray-2);
  padding-bottom: 30px;
  padding-top: 30px;
`;

export const EvTaxCreditBox = styled.div<{ hasSelectedOption: boolean }>`
  border-top: 1px solid var(--colors-neutral-gray-2);
  padding-bottom: ${props => (props.hasSelectedOption ? '30px' : '8px')};
  padding-top: 30px;
`;

export const DividerLine = styled.div`
  border-top: 1px solid var(--colors-neutral-gray-2);
  padding-top: 30px;
`;

export const BoxLabel = styled.b`
  color: #183558;
  display: inline-block;
  white-space: nowrap;
`;

export const EvLabel = styled.b<{ hasEvTaxCredit: boolean }>`
  color: ${props =>
    props.hasEvTaxCredit ? 'var(--colors-primary-green-2)' : '#757989'};
  display: inline-block;
  font-weight: ${props => (props.hasEvTaxCredit ? 'bold' : 'normal')};
`;

export const BoxText = styled.p<{ blueDark?: boolean; breakAll?: boolean }>`
  color: ${props => (props.blueDark ? '#183558' : '#757989')};
  word-break: ${props => (props.breakAll ? 'break-all' : 'break-word')};

  @media (width >= 768px) {
    word-break: ${props => (props.breakAll ? 'break-all' : 'inherit')};
  }

  &.bold {
    font-weight: bold;
  }
`;

export const BoxTextGreen = styled.p`
  color: #2f9e44;
  word-break: break-word;

  @media (width >= 768px) {
    word-break: inherit;
  }

  &.bold {
    font-weight: bold;
  }
`;

export const BoxTextBlue = styled.p`
  color: #228be6;
  word-break: break-word;

  @media (width >= 768px) {
    word-break: inherit;
  }

  &.bold {
    font-weight: bold;
  }
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
`;

export const DividerText = styled.p`
  font-size: 14px;
  padding-bottom: 10px;
  color: #757989;
`;

export const DividerText2 = styled.p`
  font-size: 14px;
  padding-bottom: 10px;
  color: #757989;
`;

export const EvDividerText = styled.p`
  font-size: 14px;
  padding-bottom: 16px;
  color: #757989;
  line-height: 20px;
`;

export const DividerText3 = styled.p`
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 10px;
  color: #757989;
`;

export const TradeMarkText = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #757989;
`;

export const List = styled.ul`
  & > b {
    margin-bottom: 16px;
    margin-top: 24px;
  }

  & > ${ListItem} {
    margin-bottom: 16px;
  }

  .shipping-delivery-container {
    margin-bottom: 0;
  }
`;

export const ShowHidewrapper = styled.div`
  display: flex;
  place-content: flex-end;
  color: #00aed9;
  font-size: 14px;
  cursor: pointer;
  padding-bottom: 16px;
`;

export const ShowHideText = styled.div`
  padding-left: 3px;
`;

export const Sublist = styled.ul`
  font-size: 14px !important;
  margin-bottom: 16px !important;
  padding-left: 20px !important;

  & > ${ListItem}:not(:last-of-type) {
    margin-bottom: 2px;
  }
`;

export const MarketplaceReminderWrapper = styled.div`
  background-color: white;
  border: 1px solid var(--colors-neutral-gray-2);
  border-radius: 4px;
  margin-top: 20px;
  padding: 32px;
`;

export const MarketplaceReminderHeading = styled.h3`
  color: #9b51e0;
  font-size: 15px;
  margin-bottom: 16px;

  > .hide-sm {
    @media (max-width: ${theme.breakpoints.xs}) {
      display: none;
    }
  }
`;

export const MarketplaceReminderText = styled.p`
  color: var(--colors-neutral-gray-5);
  font-size: 14px;
`;

export const TaxSavingsSection = styled.div`
  background-color: #f4f8fa;
  border-radius: 8px;
  width: 100%;
  height: 96px;
  display: flex;
  padding: 28px;
  gap: 9px;
  flex: none;
  align-self: stretch;
  align-items: center;
  order: 3;
  flex-grow: 0;
  margin-bottom: 15px;
`;

export const GreenBox = styled.div`
  background-color: #ebfbee;
  border-radius: 8px;
  width: 100%;
  height: 48px;
  display: flex;
  padding: 8px;
  gap: 9px;
  flex: none;
  align-self: stretch;
  align-items: center;
  order: 2;
  flex-grow: 0;
  margin-bottom: 15px;
`;

export const TaxSavingsText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;
`;

export const GreenBoxText = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #237032;
  font-weight: 450;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
`;

export const ContinueButton = styled(Button)`
  width: 251px;

  @media (min-width: ${theme.breakpoints.sm}) {
    width: 280px;
  }
`;

const summaryListRequiredProps = {
  label: (<></>) as React.ReactNode,
  value: ''
};

const summaryListOptionalProps = {
  isBold: false,
  separator: ':',
  listItemClass: '',
  breakAll: false
};

const summaryListDefaultProps: typeof summaryListRequiredProps &
  Partial<typeof summaryListOptionalProps> = {
  ...summaryListRequiredProps,
  ...summaryListOptionalProps
};

export const SummaryListItem = ({
  label,
  value,
  isBold = false,
  separator = ':',
  listItemClass = '',
  breakAll = false
} = summaryListDefaultProps) => {
  return (
    <ListItem className={listItemClass}>
      <BoxText>
        {label}
        {separator}
      </BoxText>
      <BoxText className={isBold ? 'bold' : ''} breakAll={breakAll}>
        {value}
      </BoxText>
    </ListItem>
  );
};

export const SummaryListItemGreen = ({
  label,
  value,
  isBold,
  separator,
  listItemClass
} = summaryListDefaultProps) => {
  return (
    <ListItem className={listItemClass}>
      <BoxTextGreen className={isBold ? 'bold' : ''}>
        {label}
        {separator}
      </BoxTextGreen>
      <BoxTextGreen className={isBold ? 'bold' : ''}>{value}</BoxTextGreen>
    </ListItem>
  );
};

export const SummaryListItemBlue = ({
  label,
  value,
  isBold,
  separator,
  listItemClass
} = summaryListDefaultProps) => {
  return (
    <ListItem className={listItemClass}>
      <BoxTextBlue className={isBold ? 'bold' : ''}>
        {label}
        {separator}
      </BoxTextBlue>
      <BoxTextBlue className={isBold ? 'bold' : ''}>{value}</BoxTextBlue>
    </ListItem>
  );
};

export const continueButtonSyles = css`
  margin: 50px auto;

  @media (width >= 768px) {
    margin-bottom: initial;
  }
`;
